__turbopack_context__.v({
  "colors": "dFOxAq_colors",
  "container": "dFOxAq_container",
  "root": "dFOxAq_root",
  "text": "dFOxAq_text",
  "trackGraph": "dFOxAq_trackGraph",
});
